import office from '@/taskpane/officejs/office-wrapper'
import MessageArgs from '../messages/message-args'

export interface SetCategoryArgs extends MessageArgs {
  categoryName: string
  categoryColor: string
  categoryToRemove: string
}

export default async function setCategoryHandler(data: SetCategoryArgs) {
  try {
    if (data.categoryName) {
      await office.categories.add(data.categoryName, data.categoryColor)
    }

    if (data.categoryToRemove) {
      await office.categories.remove(data.categoryToRemove)
    }
  } catch {
    // no callback
  }
}
